import type {
  CounterpartyInternalDto,
  CounterpartyManagerIdDto,
} from '@/modules/counterparty/dto/counterparty-internal.dto.ts';
import type { CounterpartyEditRequest } from '@/modules/counterparty/requests/counterparty-edit.request.ts';
import type {
  CounterpartyEditParams,
  CounterpartyInternal,
} from '@/modules/counterparty/types/counterparty-internal.type.ts';

function toPositiveId(value: unknown) {
  const id = Number(value);

  return Number.isInteger(id) && id > 0 ? id : null;
}

export class CounterpartyInternalAdapter {
  static map(response: CounterpartyInternalDto): CounterpartyInternal {
    return {
      id: response.CLIENT_ID,
      parents: response.PARENTS ?? '',
      typeId: response.TYPE_ID,
      managerId: toPositiveId(response.MANAGER_ID),
      segmentId: response.SEGMENT_ID,
      regionId: response.REGION_ID,
      legalFormId: toPositiveId(response.LF_ID),
      category: response.Приоритет ?? '',
      name: response.Название,
      discount: response.Скидка ?? 0,
      comment: response.Примечание ?? '',
      inn: response.ИНН ?? '',
      kpp: response.КПП ?? '',
      okato: response.ОКАТО ?? '',
      okpo: response.ОКПО ?? '',
      ogrn: response.ОГРН ?? '',
      position: response.Должность ?? '',
      document: response.ДУЛ ?? '',
      city: response.Город ?? '',
      code: response.Код ?? '',
    };
  }

  static mapManagerId(response: CounterpartyManagerIdDto | null | undefined) {
    return toPositiveId(response?.items?.manager_id ?? response?.manager_id);
  }

  static toEditRequest(parameters: CounterpartyEditParams): CounterpartyEditRequest {
    return {
      client_id: parameters.id,
      parents: parameters.parents,
      type_id: parameters.typeId,
      manager_id: parameters.managerId,
      region_id: parameters.regionId,
      segment_id: parameters.segmentId,
      category: parameters.category,
      name: parameters.name,
      discount: parameters.discount,
      comment: parameters.comment,
      inn: parameters.inn,
      kpp: parameters.kpp,
      okato: parameters.okato,
      okpo: parameters.okpo,
      position: parameters.position,
      document: parameters.document,
      ogrn: parameters.ogrn,
      lf_id: parameters.legalFormId,
      city: parameters.city,
      code: parameters.code,
    };
  }
}
